export default __webpack_public_path__ + "static/media/img-intro-overview-en@3x.ae539406.png";